import { h } from 'preact';
import { ATTRIBUTE } from 'src/common/constants';
import * as styles from './styles.less';

interface SidebarSocialLink {
    id: string;
    title: string;
    alt: string;
    url: string;
}

const sidebarSocialLinks: SidebarSocialLink[] = [
    {
        id: 'facebook',
        title: 'Become a fan on:',
        alt: 'Become a fan on Facebook',
        url: 'https://www.facebook.com/camcontacts',
    },
    {
        id: 'twitter',
        title: 'Follow us on:',
        alt: 'Follow us on Twitter',
        url: 'https://www.x.com/camcontacts',
    },
    {
        id: 'youtube',
        title: 'View our channel on:',
        alt: 'View our channel on YouTube',
        url: 'https://www.youtube.com/@camcontactsvideos2869',
    },
];

const SocialLinks = () => {
    return (
        <nav class={styles.social}>
            {sidebarSocialLinks.map((link: SidebarSocialLink) => {
                const linkIDClass = styles[`id__${link.id}`];
                const linkClass = `${styles.social__link} ${linkIDClass}`;
                return (
                    <div class={styles.social__item} key={link.id}>
                        {link.title}
                        <a href={link.url} class={linkClass} title={link.alt} data-native {...ATTRIBUTE.TARGET_BLANK} {...ATTRIBUTE.REL_EXTERNAL} />
                    </div>
                );
            })}
        </nav>
    );
};

export default SocialLinks;
